import { FC, useState } from 'react'
import { SiteModel } from '../../../core/_models'
import { formatEUR } from '_metronic/partials/widgets/tables/TenderListWidget'

type Props = {
  site: SiteModel
}
const NationalContribution: FC<Props> = ({ site }) => (

  <div className='d-flex align-items-center'>
    {site.nationalContributionEur !== undefined && site.nationalContributionEur !== null && formatEUR(site.nationalContributionEur.toFixed(2))}
  </div>

)
export { NationalContribution }
